import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button } from "./vendor";
import CSSModules from "lib/utils/css-modules";

import styles from "./AutoTranslateButton.less";

@CSSModules(styles)
class AutoTranslateButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false,
    };
  }

  render() {
    return (
      <div>
        <Button
          primary
          content={I18n.t("papp.products.EditProductView.menu.translate")}
          styleName="auto-translate-button"
          onClick={() => this.props.handleToggleModal(true)}
        />
      </div>
    );
  }
}

AutoTranslateButton.propTypes = {
  handleToggleModal: PropTypes.func.isRequired,
};

export default AutoTranslateButton;



// WEBPACK FOOTER //
// ./src/lib/components/AutoTranslateButton.jsx